export const weightMap = {
  thin: 200,
  regular: 400,
  medium: 500,
  demi: 600,
  bold: 700,
  heavy: 800
};
export const variantMap = {
  'display-1': 'span',
  'display-2': 'span',
  'display-3': 'span',
  'display-4': 'span',
  'headline-1': 'h1',
  'headline-2': 'h2',
  'headline-3': 'h3',
  'headline-4': 'h4',
  'headline-5': 'h5',
  'headline-6': 'h6',
  'body-1': 'span',
  'body-2': 'span',
  'body-3': 'span',
  'body-4': 'span',
  inherit: 'span'
};
//# sourceMappingURL=Typography.types.js.map